import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";

import Slider from "react-slick";
import "./../styles/Publications.scss";
import MonthlyPublish from "./../components/MonthlyPublish";
import EnergyProductivity from "./../components/EnergyProductivity";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Api from "../common/api";

const Publications = () => {

  const [tabs, setTabs] = useState([
    {
      id: 1,
      Name: "Aylık Enerji Bültenlerimiz",
      content: "",
    }
  ]);

  const lang = localStorage.getItem("lang");
  let size = 2;
  if(lang == "en"){
    size = 3;
  }

  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[size]
  );
  const [currentTab, setCurrentTab] = useState([]);
  const [isMobileActive, setIsMobileActive] = useState(true);
  const [banner, setBanner] = useState([]);

  React.useEffect(() => {
    Api.get("/home/getmenu?slug=" + Paths[size-1]).then((res) => {
      setTabs(res.data.items);
      setBanner(res.data.banner);
     if(lang == "en"){
      setCurrentTab(
        res.data.items[res.data.items.findIndex((x) => x.Link_EN == activePath)]
      );
    }else{
      {
        setCurrentTab(
          res.data.items[res.data.items.findIndex((x) => x.Link == activePath)]
        );
      }
    }
    });
  }, [activePath]);

  let settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 5,
    initialSlide: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const adClick = (id) => {
    const tab = tabs.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsMobileActive(true);
  };

  const renderTitle = () => {
    if (currentTab) {
      if(lang == "en"){
        return <h3>{currentTab.Name_EN}</h3>;
      }else{
        return <h3>{currentTab.Name}</h3>;
      }
      
    }
  };

  function RenderData(tab) {
    if (tab.content.id) {
      if (tab.content.id === 1049) {
        return (
          <>
            <div className="career-container container-sm">
              <MonthlyPublish />
            </div>
          </>
        );
      }

      if (tab.content.id === 1051) {
        return (
          <div className="career-container container-sm">
            <EnergyProductivity />
          </div>
        );
      }
    } else {
      return "";
    }
  }

  return (
    <>
      <header
        className="contact-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="slider-deneme career-slider">
        <Slider className="slider-tab" {...settings}>
          {tabs && currentTab
            ? tabs.map((tab) => {
                return (

                  lang == "en" ? (
                    tab.Name_EN ? (
                  <Link
                    className={currentTab.id === tab.id ? "active" : null}
                    key={tab.id}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name_EN}
                  </Link>
                  ):""
                  ):(

                    tab.Name ? (
                    <Link
                    className={currentTab.id === tab.id ? "active" : null}
                    key={tab.id}
                    onClick={() => adClick(tab.id)}
                  >
                    {tab.Name}
                  </Link>
                  ):""

                  )
                );
              })
            : null}
        </Slider>
      </div>

      <div className="breadcrumbz container-sm ">
        {lang == "en" ? (
        <ol>
          <li>
            <Link to="/en">
              Homepage <span>&gt;</span>
            </Link>
          </li>
          <li>
            <a href="/en/publications/Our-Monthly-Energy-Newsletters">
              Publications <span>&gt;</span>
            </a>
          </li>
          <li>
            {tabs.length > 0 || currentTab.id ? (
              <Link to={Paths[1]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        ):
        (<ol>
          <li>
            <Link to="/">
              Anasayfa <span>&gt;</span>
            </Link>
          </li>
          <li>
            <a href="/yayinlar/aylik-enerji-bultenlerimiz">
              Yayınlar <span>&gt;</span>
            </a>
          </li>
          <li>
            {tabs.length > 0 || currentTab.id ? (
              <Link to={Paths[1]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        )}
      </div>

      <div
        className={
          isMobileActive ? "mobile-santral-tabs active" : "mobile-santral-tabs"
        }
      >
        {tabs && currentTab
          ? tabs.map((tab) => {
              return (
                lang == "en" ? (
                  tab.Name_EN? (
                  <li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  onClick={() => adClick(tab.id)}
                  key={tab.id}
                >
                  <span>{tab.Name_EN}</span>
                </li>
                ):""

                ):(

                  tab.Name ? (
                  <li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  onClick={() => adClick(tab.id)}
                  key={tab.id}
                >
                  <span>{tab.Name}</span>
                </li>
                ):""

                )
              );
            })
          : null}
      </div>
      <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>

      <Route>
        <RenderData content={currentTab} />
      </Route>
    </>
  );
};

export default Publications;
